module.exports = "https://static.wanderu.com/static/media/economist.304926db.png";